export const modelListGridId = 'modelList';
export const dynamicSearchGridId = 'dynamicList';
export const userListGridId = 'userList';
export const incidentListGridId = 'incidentList';
export const notificationsListGridId = 'notificationsList';
export const externalizationListGridId = 'externalizationList';
export const externalUserDetailGridId = 'externalUserDetail';
export const scenarioExecutionQueueGridId = 'scenarioExecutionQueue';
